import { ClientWithAuth } from 'client/services/service';
import { getEpsgCode } from 'client/utils/helpers/MapConfig/MapConfig';

const serviceUrlSuffix = '/observation-service';

export default {
    getObservationTypes: async () => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/${epsgCode}/observationTypes`);
        return response.data;
    },
    createObservation: async (observation) => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.post(`${serviceUrlSuffix}/${epsgCode}/me/observations`, JSON.stringify(observation));
        return response.data;
    },
    getObservations: async (params) => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/${epsgCode}/me/observations`, { params });
        return response.data;
    },
    getObservation: async (observationId) => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/${epsgCode}/me/observations/${observationId}`);
        return response.data;
    },
    editObservation: async (observation) => {
        const allowedFields = ['systemId', 'objectName', 'observationCategory', 'notes', 'dataSensitivityLevel', 'systemLoadDate', 'geometry', 'lifeCycleStatus', 'potentialSensitivity', 'userId', 'visibilityStatus', 'scopeOfSharing'];
        Object.keys(observation).forEach(key => {
            if (!allowedFields.includes(key)) {
                delete observation[key];
            }
        });
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.patch(`${serviceUrlSuffix}/${epsgCode}/me/observations`, JSON.stringify(observation));
        return response.data;
    },
    deleteObservations: async (systemIds) => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.delete(`${serviceUrlSuffix}/${epsgCode}/me/observations`, { data: systemIds });
        return response?.data;
    }
};
